import { atom } from "recoil";

export const addStateGLEntity = atom({
  key: "addStateGLEntity",
  default: false,
});
export const editStateGLEntity = atom({
  key: "editStateGLEntity",
  default: false,
});
export const rowEditIdStateGLEntity = atom({
  key: "rowEditIdStateGLEntity",
  default: null,
});
export const disableButtonStateGLEntity = atom({
  key: "disableButtonStateGLEntity",
  default: false,
});

export const selectedRowsStateGLEntity = atom({
  key: "selectedRowsStateGLEntity",
  default: [],
});

export const setFilterTextGLEntity = atom({
  key: "setFilterTextGLEntity",
  default: "",
});
